function isFacebookInAppBrowser() {
  if (typeof window === "undefined") return false;
  const ua = navigator.userAgent ?? "";
  return ["FBAN", "FBAV", "Instagram"].some(str => ua.includes(str));
}

export default isFacebookInAppBrowser;
